require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-mitchell-robertson.json") })
        }
      }, "path---blog-author-mitchell-robertson");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-mitchell-robertson!./.cache/json/blog-author-mitchell-robertson.json
// module id = 690
// module chunks = 231608221292675